<input
  id="aside-drawer"
  type="checkbox"
  class="drawer-toggle"
  [(ngModel)]="showDrawer"
/>

<div
  class="bg-base-100/90 text-base-content sticky top-0 z-1000 flex h-16 w-full [transform:translate3d(0,0,0)] justify-center backdrop-blur transition-shadow duration-100 print:hidden"
>
  <nav class="navbar w-full pt-0 py-0">
    <div class="flex flex-1 items-center md:gap-1 lg:gap-2">
      <span
        class="tooltip tooltip-bottom before:text-xs before:content-[attr(data-tip)]"
        data-tip="Menu"
      >
        <label
          aria-label="Open menu"
          for="aside-drawer"
          class="btn btn-square btn-ghost drawer-button lg:hidden"
        >
          <svg-icon
            src="./assets/icons/menu.svg"
            [svgClass]="'inline-block h-5 w-5 stroke-current md:h-6 md:w-6'"
          ></svg-icon>
        </label>
      </span>
      <div class="flex items-center gap-2">
        <a
          href="/"
          aria-current="page"
          aria-label="daisyUI"
          class="me-2 flex w-35 shrink-0 items-center gap-2 lg:hidden"
        >
          <svg-icon
            src="./assets/icons/lottie/wave-lines-still.svg"
            [svgClass]="''"
          ></svg-icon>
          <!--          <div class="w-35 h-18 text-base-content">-->
          <!--            <ng-lottie [options]="theme === 'light' ? options_light : options_dark" (animationCreated)="animationCreated($event)" />-->
          <!--          </div>-->
          <svg-icon
            src="./assets/icons/logo_analyzr_black.svg"
            [svgClass]="'absolute h-6 w-18 text-base-content p0 -ml-28 -mt-3'"
          ></svg-icon>
        </a>
        <div class="lg:hidden">
          <app-drop-down></app-drop-down>
        </div>
      </div>
    </div>

    <div class="flex xl:gap-1">
      <div class="hidden flex-none items-center lg:inline-block ml-4">
        <a
          routerLink="/dashboard"
          [routerLinkActive]="['active', 'disabled']"
          [routerLinkActiveOptions]="{ exact: true }"
          class="btn btn-sm btn-ghost drawer-button font-normal"
        >
          <svg-icon
            src="./assets/icons/heroicons/optimized/24/outline/rectangle-group.svg"
            [svgClass]="'w-4 h-4 text-blue-600'"
          ></svg-icon>
          Dashboard
        </a>
      </div>

      <!-- Pricing -->
      <div class="hidden flex-none items-center lg:inline-block ml-4">
        <a
          routerLink="/dashboard/pricing"
          [routerLinkActive]="['active', 'disabled']"
          class="btn btn-sm btn-ghost drawer-button font-normal"
        >
          <div class="w-4 h-4 text-base-content">
            <svg-icon
              src="./assets/icons/heroicons/optimized/24/outline/tag.svg"
              svgClass="w-4 h-4 text-base-content"
            ></svg-icon>
          </div>
          Pricing
        </a>
      </div>

      <!-- Docs -->
      <div class="hidden flex-none items-center lg:inline-block ml-4">
        <a
          routerLink="/dashboard/docs"
          [ngClass]="{'active disabled': isDocsRoute}"
          class="btn btn-sm btn-ghost drawer-button font-normal"
        >
          <div class="w-4 h-4 text-base-content">
            <svg-icon
              src="./assets/icons/heroicons/optimized/24/outline/document-text.svg"
              svgClass="w-4 h-4 text-base-content"
            ></svg-icon>
          </div>
          Docs
        </a>
      </div>

      <!-- Theme Switcher -->
      <div
        tabindex="0"
        role="button"
        class="btn group btn-sm gap-1.5 px-1.5 btn-ghost ml-4"
        aria-label="Change Theme"
        (click)="changeTheme($event)"
        [attr.data-set-theme]="theme === 'light' ? 'dark' : 'light'"
        [attr.title]="theme === 'light' ? 'Switch to Moon side!' : 'Switch to Sun side!'"
      >
        <div class="w-4 h-4 text-base-content">
          <svg-icon
            [src]="theme === 'light' ? './assets/icons/heroicons/optimized/24/outline/moon.svg' : './assets/icons/heroicons/optimized/24/outline/sun.svg'"
            svgClass="text-base-content w-4 h-4"
          ></svg-icon>
        </div>
      </div>

      <!-- Language Selector -->
      <!--      <app-drop-down-language></app-drop-down-language>-->

      <!-- Logout Button -->
      <button
        type="button"
        class="btn btn-sm btn-ghost gap-1 px-1.5 ml-4"
        aria-label="Logout"
        title="Logout"
        (click)="onLogout()"
      >
        <svg-icon
          src="./assets/icons/heroicons/optimized/24/outline/arrow-right-start-on-rectangle.svg"
          [svgClass]="'w-4 h-4 text-red-500'"
        ></svg-icon>
        <span class="hidden sm:inline">Logout</span>
      </button>
    </div>
  </nav>
</div>
